import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidebarDividerNextUniDriver extends BaseUniDriver {
  isFullWidth: () => Promise<boolean>;
  getSkin: () => Promise<string>;
}
